module.exports = __webpack_public_path__ + "img/welcome_bg_new_qj.a5726d84.jpg";